import * as React from "react";
const SvgFiRrLacrosseStick = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lacrosse-stick_svg__a)">
      <path
        fill="#062147"
        d="M23.957 7.593c-.203-1.827-1.096-3.615-2.516-5.034S18.234.247 16.407.043C14.5-.17 12.77.39 11.542 1.615c-.914.913-1.462 2.121-1.585 3.493-.08.887-.635 1.757-1.524 2.39C6.471 8.89 5.59 11.325 6.19 13.698c.168.666.47 1.284.86 1.838L.292 22.293a.999.999 0 1 0 1.414 1.414l6.756-6.756a5.6 5.6 0 0 0 1.84.86c.494.124.992.185 1.482.185 1.86 0 3.615-.875 4.718-2.429.631-.889 1.501-1.444 2.39-1.523 1.371-.124 2.578-.673 3.491-1.586 1.227-1.226 1.785-2.954 1.573-4.865m-2.987 3.451c-.577.578-1.358.927-2.257 1.008-1.47.132-2.87.991-3.84 2.357-.926 1.305-2.49 1.866-4.08 1.462a3.72 3.72 0 0 1-2.664-2.662c-.402-1.59.158-3.155 1.462-4.08 1.366-.972 2.226-2.37 2.358-3.84.081-.9.43-1.68 1.007-2.259C13.63 2.357 14.564 2 15.63 2q.273 0 .556.031c1.378.153 2.742.843 3.841 1.942 1.1 1.1 1.79 2.463 1.942 3.841.144 1.294-.21 2.441-1 3.23z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lacrosse-stick_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLacrosseStick;
